import * as Yup from 'yup';

export const ChangePasswordSchema = Yup.object().shape({
  oldPassword: Yup.string()
    .min(1, 'Current Password is required')
    .required('Please provide your Current Password'),
  newPassword: Yup.string()
    .min(8, 'Password must be at least 8 characters long')
    .matches(
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]/,
      'Password must contain at least one uppercase letter, one lowercase letter, one number, and one special character',
    )
    .required('Please provide your New Password'),
  confirmPassword: Yup.string()
    .min(8, 'Confirm New Password is required')
    .required('Please confirm your new password')
    .oneOf([Yup.ref('newPassword')], 'Passwords must match'),
});

export type ChangePasswordDataType = Yup.InferType<typeof ChangePasswordSchema>;

type InitialValues = {
  oldPassword: string;
  newPassword: string;
  confirmPassword: string;
};

export const changePasswordInitialValues: InitialValues = {
  oldPassword: '',
  newPassword: '',
  confirmPassword: '',
};

export interface ChangePasswordInterface {
  oldPassword: string;
  newPassword: string;
  confirmPassword: string;
}
